/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  TestFeeCollector,
  TestFeeCollectorInterface,
} from "../TestFeeCollector";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "platformFeeReceiver",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "FeeCollectorPlatformFeeReceiverRequired",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "platform",
        type: "uint16",
      },
      {
        internalType: "uint16",
        name: "creator",
        type: "uint16",
      },
      {
        internalType: "uint16",
        name: "referral",
        type: "uint16",
      },
    ],
    name: "FeeCollectorRevenueShareFeesRequired",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "maxFeeSum",
        type: "uint256",
      },
    ],
    name: "FeeCollectorRevenueShareFeesTooHigh",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "expectedAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "receivedAmount",
        type: "uint256",
      },
    ],
    name: "FeeCollectorShareRevenuePaymentFailed",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [],
    name: "baseRevenueShareFee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "feeBalance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "platformFeeReceiver",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "revenueShareFees",
    outputs: [
      {
        components: [
          {
            internalType: "uint16",
            name: "platform",
            type: "uint16",
          },
          {
            internalType: "uint16",
            name: "creator",
            type: "uint16",
          },
          {
            internalType: "uint16",
            name: "referral",
            type: "uint16",
          },
        ],
        internalType: "struct IFeeCollector.RevenueShareFees",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "platformFeeReceiver_",
        type: "address",
      },
    ],
    name: "setPlatformFeeReceiver",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "platformFee",
        type: "uint16",
      },
      {
        internalType: "uint16",
        name: "creatorFee",
        type: "uint16",
      },
      {
        internalType: "uint16",
        name: "referralFee",
        type: "uint16",
      },
    ],
    name: "setRevenueShareFees",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "feeToken",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "referrer",
        type: "address",
      },
      {
        components: [
          {
            internalType: "address",
            name: "receiver",
            type: "address",
          },
          {
            internalType: "uint96",
            name: "share",
            type: "uint96",
          },
        ],
        internalType: "struct RoyaltySharesLib.RoyaltyShare[]",
        name: "creatorRoyalties",
        type: "tuple[]",
      },
      {
        internalType: "bytes",
        name: "dataForCallback",
        type: "bytes",
      },
    ],
    name: "shareRevenue",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "referrer",
        type: "address",
      },
    ],
    name: "testOnlyCalculateRevenueShare",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "testOnlySetFeeBalance",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "feeTokenList",
        type: "address[]",
      },
    ],
    name: "withdrawTokens",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "accountList",
        type: "address[]",
      },
      {
        internalType: "address[]",
        name: "feeTokenList",
        type: "address[]",
      },
    ],
    name: "withdrawTokensForMany",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
];

const _bytecode =
  "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";

export class TestFeeCollector__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    platformFeeReceiver: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<TestFeeCollector> {
    return super.deploy(
      platformFeeReceiver,
      overrides || {}
    ) as Promise<TestFeeCollector>;
  }
  getDeployTransaction(
    platformFeeReceiver: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(platformFeeReceiver, overrides || {});
  }
  attach(address: string): TestFeeCollector {
    return super.attach(address) as TestFeeCollector;
  }
  connect(signer: Signer): TestFeeCollector__factory {
    return super.connect(signer) as TestFeeCollector__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): TestFeeCollectorInterface {
    return new utils.Interface(_abi) as TestFeeCollectorInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): TestFeeCollector {
    return new Contract(address, _abi, signerOrProvider) as TestFeeCollector;
  }
}
